export default __webpack_public_path__ + "static/media/yogo.2afcf681.jpg";